/** Relative time labels aligned with trashie-mobile `getRelativeTime`. */
function getRelativeNotificationTime(dateString) {
  const parsed = new Date(dateString).getTime();
  if (Number.isNaN(parsed)) return '';
  const diffMins = Math.floor((Date.now() - parsed) / 60000);
  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins} min${diffMins !== 1 ? 's' : ''}`;
  const diffHrs = Math.floor(diffMins / 60);
  if (diffHrs < 24) return `${diffHrs} hr${diffHrs !== 1 ? 's' : ''}`;
  const diffDays = Math.floor(diffHrs / 24);
  return `${diffDays} day${diffDays !== 1 ? 's' : ''}`;
}

export default getRelativeNotificationTime;
